export default __webpack_public_path__ + "static/media/Portronics.7d7f5b28.jpg";